const div = document.getElementById('calmac-app');
const route = div?.getAttribute('data-route');
const mapPlaceholderImage = div?.getAttribute('data-mapimage') ?? '';

const config = {
  route,
  mapPlaceholderImage,
};

export default config;
